<script setup lang="ts">
import type { Dealer } from '~/types/dealer.type'

const { dealer } = defineProps<{
  dealer: Dealer
}>()
const { t } = useI18n({})
</script>

<template>
  <div class="flex flex-col md:flex-row">
    <div class="flex md:w-1/2">
      <div class="bg-background my-8 flex w-full flex-col gap-4 rounded-lg py-20 px-10">
        <div class="flex flex-row items-center justify-between px-2">
          <div class="text-2xl font-bold">
            {{ dealer?.title }}
          </div>
          <div v-if="dealer.type === 'hubo'">
            <img src="~/assets/images/hubo.svg" alt="Hubo">
          </div>
        </div>

        <div class="px-2 text-lg">
          <span>{{ dealer.street_number ? `${dealer.street.trim()}${dealer.street_number.trim()},` : `${dealer.street.trim()},` }}</span>
          <div>{{ dealer?.zip_code }} {{ dealer?.city }}</div>
          <div>{{ t(`countries.${dealer?.country.toLowerCase()}`) }}</div>
        </div>

        <DealerWebsite :dealer="dealer" />
      </div>
    </div>

    <div class="shadow-input z-20 -mt-20 h-80 px-4 md:mt-0 md:h-auto md:w-1/2 md:px-0">
      <DealerGoogleMap :dealer="dealer" />
    </div>
  </div>
</template>
